import { Component, inject } from '@angular/core';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-conditional-number-form',
  templateUrl: './conditional-number-form.component.html',
  styleUrls: ['./conditional-number-form.component.scss']
})
export class ConditionalNumberFormComponent {
  surveyConditionalsService = inject(SurveyConditionalsService);

  onSelectValueToMatch(): void {
    this.surveyConditionalsService.onUpdateNumberOperatorValues();
  }
}
